// Auto-generated skeleton for Privacy

export const Privacy: Api.Privacy = {
  id: 0,
  content: '',
  created: null,
  updated: null,
};

